import { SwiperSlide,Swiper } from "swiper/react";
import { Navigation } from "swiper";
import Card from "./Card";
import "swiper/css";
import "swiper/css/navigation";
import useGroup from "../Hooks/useGroup";
import CardAlt from "./CardAlt";
import ActorCard from "./ActorCard";

const Category = ({data,name,cardType})=>{
    const {col,space} = useGroup();
   
    return <div className="lg:px-8 md:mt-4 mt-2 md:px-4 px-2 text-headline dark:text-headline-dark font-heading lg:text-lg md:text-md text-sm">
        {
            (data.length>0)?
            <>
                <h3>{name}</h3>
                <Swiper
                    slidesPerView={col}
                    spaceBetween={space}
                    slidesPerGroup={col}
                    autoHeight={true}
                    navigation={true}
                    modules={[Navigation]} 
                    className="mySwiper"
                >
                    {data.map(item=>{
                        return <SwiperSlide key={item.id} >
                            {
                                (cardType==='movie')?
                                <Card movie={item}/>
                                :
                                (cardType==='actor')?
                                <ActorCard actor={item}/>
                                :
                                <CardAlt movie={item}/>
                            }
                        </SwiperSlide>
                    })}
                </Swiper>
            </>
            :
            null
        }
    </div>
}

export default Category;